// extracted by mini-css-extract-plugin
export var activityContainer = "_6p-0";
export var typingIndicatorContainer = "_6p-1";
export var typingIndicatorDot = "_6p-2";
export var wave = "_6p-3";